import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Events, Item, } from 'ionic-angular';

@Component({
  selector: 'button-type-renderer',
  templateUrl: 'button-type-renderer.html'
})
export class ButtonTypeRendererComponent implements ICellRendererAngularComp {
  showList: any = false;
  text: string;
  cellValue: any;
  label: string;
  optStyle: any;
  options: any = [];
  defaultColour: any = {};
  showStatus: any = false;
  selectedOpt: any;
  statusIdx: boolean;
  docPreviousElem: any;
  docPrviousIdx: any;
  constructor(public events: Events) {
  }

  agInit(params: any): void {
    this.cellValue = params;
    this.label = params.value || null;
    this.options = params.option;
    this.optStyle = params.option.find(Item => Item.key == this.label);
    if (!this.optStyle) {
      this.defaultColour = {}
    }
  }

  refresh(params?: any): boolean {
    this.cellValue = params;
    return true;
  }

  onClick(e) {
    // alert ('data');
    if (this.cellValue.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: e,
        rowData: this.cellValue.node.data,
        type: 'update',
        rowIndex: this.cellValue.rowIndex
        // ...something
      }
      this.cellValue.onClick(params);
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/agGridRenderer/button-type-renderer/button-type-renderer.ts